const ProjectAccessHelpers = {
    swr: {
        list: (projectId: string) => `/projects/${projectId}/access-requests`,
        pendingForTeam: (teamId: string) => `/teams/${teamId}/access-requests/pending`,
    },
};

export { ProjectAccessHelpers };
